import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import MicroQualificationService from "../../services/MicroQualificationService";

let initialState = {
    groupEPs: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllGroupEps = createAsyncThunk(
    'getAllGroupEps',
    async ({page, limit}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await MicroQualificationService.getEducationProgramsGroup(page, limit);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const groupEpsSlice = createSlice({
    name: 'groupEpsSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllGroupEps.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllGroupEps.fulfilled, (state, action) => {
                state.isLoading = false;
                state.groupEPs = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllGroupEps.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.groupEPs = [];
                state.hasMore = false;
            })
    }
});

export const {} = groupEpsSlice.actions;

export default groupEpsSlice.reducer;